import {
	IonButton,
	IonCol,
	IonImg,
	IonLabel,
	IonModal,
	IonRow,
	IonText,
	IonContent,
	IonRefresher,
	IonRefresherContent,
	isPlatform,
} from "@ionic/react";
import { RefresherEventDetail } from "@ionic/core";
import React, { useEffect, useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import "../Booking/BookingDetails.scss";
import * as constants from "../../../constants";
import BookingDetailsBanner from "./BookingsDetBanner";
import {
	fetchBookingWithId,
	getMultiServiceData,
	getTimeSlots,
	saveServiceData,
	uploadBookingImage,
	deleteBookingImage,
	deleteBookingTransaction,
	rescheduleBooking,
	cancelBooking,
	fetchBookings,
	// fetchReservationsFeedback,
	getBookingEvents,
	getWorkshopImages,
	fetchFeedback,
	razorpayCallBack,
	saveBookingDetailsHeaderStatus,
	clearParticularBooking,
	getAdvancePaymentOrderId,
} from "../../../Store/Actions";
import { connect } from "react-redux";
import Calendar from "react-calendar";
import moment from "moment";
import UserAddressModal from "../../../utils/UserAddressModal";
import AddNewAddress from "../../Portal/addNewAddress";
import { CustomIonImage } from "../../CustomComponents/IonImg";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { AlertMessage } from "../../../utils/alertMessage";
import { timeLineArr } from "../../../utils/service_timeline";
import { ToastMessage } from "../../../utils/toastMessage";
import FeedbackModal from "../Booking/feedback";
// import { bookingConfirmed, bookingCancelled } from "../../../utils";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { checkMediaQuery } from "../../../utils";
import { contractOutline } from "ionicons/icons";

const options: CameraOptions = {
	destinationType: Camera.DestinationType.DATA_URL,
	sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
	encodingType: Camera.EncodingType.JPEG,
};

function usePrevious(value: any) {
	const ref = React.useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

const BookingDetails: React.FC = (props: any) => {
	const { idOfBooking, paymentStatus = "" } = props.location.state;
	const ref = React.useRef();
	const prevData = usePrevious(props.sliderCatelogVehicleId);
	React.useEffect(() => {
		if (
			!!props.sliderCatelogVehicleId &&
			!!prevData &&
			prevData !== props.sliderCatelogVehicleId
		) {
			props.history.goBack();
		}
		return () => {};
	}, [props.sliderCatelogVehicleId]);
	const { particularBookingDetails = [], service_data_value } = props;
	const data_obj = !!particularBookingDetails.length ? particularBookingDetails[0] : "";
	const [showCalendar, setShowCalendar] = useState(false);
	const [date, setDate] = useState(new Date());
	const [dateTemp, setDateTemp] = useState(new Date());

	const [wshopImages, setWshopImages] = useState<any>([]);

	const [slot, setTimeSlot] = useState("");
	const [showSlotModal, setShowSlotModal] = useState(false);
	const [BkngDetails, setBkngDetails] = useState<any>([]);
	const [showAddModal, setShowAddModal] = useState(false);
	const [showMap, setShowMap] = useState(false);
	const [address_label, setAddressLabel] = useState("");
	const [pick_add, setPickAdd] = useState([]);
	const [drop_add, setDropAdd] = useState([]);
	const [alert, showAlert] = useState(false);
	const [showFeedback, setShowFeedBack] = React.useState(false);
	const [showPaymentPendingCard, setShowPaymentPendingCard] = React.useState(false);
	const [pickedUpStatus, setpickedUpStatus] = useState(false);
	const [paymentSuccess, setPaymentSuccess] = useState("");
	const [userUploadedImages, setUserUploadedImages] = useState<any>([]);
	const [hideCancelButton, setHideCancelButton] = useState(false);
	const [time_arr, setTimeArray] = useState([]);

	const [userCartImgs, setUserCartImgs] = useState<any>([]);
	const [userServImgs, setUserServImgs] = useState<any>([]);

	// useEffect(() => {
	//   setPaymentSuccess(paymentStatus);
	// }, [paymentStatus]);

	useEffect(() => {
		if (
			!!data_obj &&
			!!data_obj.pickupDropoffData &&
			!!data_obj.pickupDropoffData.pickupDate
		) {
			setDate(new Date(data_obj.pickupDropoffData.pickupDate));
		} else {
			setDate(new Date());
		}
	}, [data_obj, particularBookingDetails[0], props.bookingList]);

	// const getFeedBacklink = async () => {
	//   if (props.userVehiclesList.length && props.sliderCatelogVehicleId) {
	//     const registrationNumberList = props.userVehiclesList.filter(
	//       (ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId,
	//     );
	//     const respo = await props.fetchReservationsFeedback(
	//       registrationNumberList[0].registrationNumber,
	//     );
	//     if (!!respo.feedbackLink) {
	//       window.open(respo.feedbackLink, "_blank");
	//     } else {
	//       setToast({
	//         showToast: true,
	//         toastMessage: "Hey! still, we are waiting to receive your car to Garage",
	//         severity: "warning",
	//       });
	//     }
	//   }
	// };

	const arr =
		!!particularBookingDetails.length && !!particularBookingDetails[0].events.length
			? particularBookingDetails[0].events
			: timeLineArr;

	const timeLineGroup = arr.reduce((prev: any, cur: any) => {
		prev[cur.category] = prev[cur.category] || [];
		prev[cur.category].push(cur);
		return prev;
	}, {});

	var statusArr = Object.keys(timeLineGroup).map((ele: any) => ({
		key: ele,
		details: timeLineGroup[ele],
		active: timeLineGroup[ele].some((x: any) => !!x.updatedAt),
	}));

	const progressPercentage = statusArr.map((v1: any) => {
		return (
			(v1.details.filter((ele: any) => ele.updatedAt).length / v1.details.length) * 100
		);
	});

	statusArr = statusArr.map((ele: any, ind: any) => {
		return {
			...ele,
			percentage: progressPercentage[ind],
		};
	});

	useEffect(() => {
		handlePaymentCard();
		setUserUploadedImages([]);

		// console.log("data_obj =====", data_obj);
		if (!!data_obj && data_obj.items !== null) {
			if (data_obj.items.length) {
				const cartImgs = !!data_obj.userImages
					? data_obj.userImages.map((img: any) => {
							return { imgUrl: img, type: "userImages" };
					  })
					: [];

				const serviceImgs = data_obj.items.reduce((acc: any, curr: any) => {
					return [
						...acc,
						...(!!curr.images
							? curr.images.map((ele: any) => ({
									imgUrl: ele,
									type: "serviceImages",
									cartItemId: curr.cartItemId,
							  }))
							: []),
					];
				}, []);

				setUserUploadedImages([...cartImgs, ...serviceImgs]);
			}
		}
	}, [particularBookingDetails, props.bookingList]);

	const handlePaymentCard = () => {
		if (!!particularBookingDetails.length && !!particularBookingDetails[0].events) {
			const paymentPendingIndex = (particularBookingDetails[0].events || []).findIndex(
				(item: any, ind: any) => item.name === "Payment Pending"
			);
			if (
				paymentPendingIndex &&
				!!particularBookingDetails[0].events[paymentPendingIndex - 1].updatedAt &&
				!particularBookingDetails[0].events[paymentPendingIndex].updatedAt
			) {
				setShowPaymentPendingCard(true);
			} else {
				setShowPaymentPendingCard(false);
			}
		}
	};

	const isPickedUp = () => {
		const pickedUpIndex = arr.findIndex(
			(item: any, ind: any) => item.name === "Picked Up"
		);
		if (pickedUpIndex && !!arr[pickedUpIndex].updatedAt) {
			setpickedUpStatus(false);
		} else {
			setpickedUpStatus(true);
		}
	};

	const isStatusPickupScheduled = () => {
		// const statusIndex = arr.findIndex(
		// 	(item: any, ind: any) => item.name === "Pickup Scheduled"
		// );
		const statusIndex = arr.findIndex(
			(item: any, ind: any) => item.name === "Picked Up" && item.updatedAt !== null
		);
		// console.log("242  === ", arr);
		if (statusIndex && !!arr[statusIndex] && !!arr[statusIndex].updatedAt) {
			setHideCancelButton(true);
		} else {
			setHideCancelButton(false);
		}
	};

	useEffect(() => {
		fetchBookingDetails();
		handlePaymentCard();
		isPickedUp();
		// return () => {
		setBkngDetails([]);
		props.clearParticularBooking();
		// };
	}, []);

	useEffect(() => {
		isStatusPickupScheduled();
	}, [data_obj]);

	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	const arrayToString = (item: any) => {
		const address_string = !!item
			? item.map((ele: any) => {
					return `${ele.addressline1},
        ${ele.landmark},
        ${ele.city},
        ${ele.postalCode},
        ${ele.country}`;
			  })
			: "";
		return address_string;
	};

	const DisplayName = (item: any) => {
		const name = !!item
			? item.map((ele: any) => {
					return ele.addressType;
			  })
			: "";
		return name;
	};

	const days = ["Mon", "Tue", "Wed", "Thr", "Fri", "Sat", "Sun"];
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"June",
		"July",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];

	React.useEffect(() => {
		// console.log("Time date received", props.time_slots);

		var currDate: Date = new Date();
		currDate.setHours(0, 0, 0, 0);

		let timeSlotCheckIsRequired = false;
		// if (dateTemp.getTime() === currDate.getTime()) {
		//   console.log("Selected date is same date");
		//   timeSlotCheckIsRequired = true;
		// } else if (dateTemp.getTime() < currDate.getTime()) {
		//   console.log("Selected date is lower date");
		//   setToast({
		//     showToast: true,
		//     toastMessage: "Invalid date",
		//     severity: "warning",
		//   });
		//   setTimeArray([]);
		//   return;
		// } else {
		//   console.log("Selected date is higher date");
		// }

		let curDt: Date = new Date(currDate);
		curDt.setHours(0, 0, 0, 0);

		let tempDt: Date = new Date(dateTemp);
		tempDt.setHours(0, 0, 0, 0);

		console.log("Date === ", dateTemp > currDate);

		if (tempDt >= curDt) {
			console.log("Selected date is same date ..... 0");
			timeSlotCheckIsRequired = true;
		} else {
			// setToast({
			// 	showToast: true,
			// 	toastMessage: "Invalid date",
			// 	severity: "warning",
			// });
			setTimeArray([]);
			return;
		}

		let timeDt = dateTemp;

		if (timeSlotCheckIsRequired) {
			const timeArr = props.time_slots.filter((ele: any) => {
				timeDt.setHours(parseInt(ele.startTime.split(":")[0]));
				return timeDt > currDate;
			});
			setTimeArray(timeArr);
		} else {
			setTimeArray(props.time_slots);
		}
	}, [props.time_slots]);

	const changeDate = (d: any) => {
		setDate(d);
		setDateTemp(d);
		var dateFormat = moment(new Date(d)).format("DD/MM/YYYY");
		// if (d >= new Date(props.firstAvailable) && d <= new Date(props.lastAvailable)) {
		//   props.getTimeSlots(dateFormat, getWorkShopId[0]);
		// }

		let fDate = new Date();
		let lDate = new Date();

		if (props.firstAvailable.length > 0) {
			fDate = new Date(props.firstAvailable);
			lDate = new Date(props.lastAvailable);
		}

		fDate.setHours(0, 0, 0, 0);
		lDate.setHours(0, 0, 0, 0);

		// if (d >= new Date(props.firstAvailable) && d <= new Date(props.lastAvailable)) {
		if (d.getTime() >= fDate.getTime()) {
			// && d.getTime() <= lDate.getTime()) {
			props.getTimeSlots(dateFormat, getWorkShopId[0]);
		}
	};

	const changeTimeSlot = (slot: any) => {
		setTimeSlot(slot);
	};

	const getWorkShopId = props.bookingList
		.filter((ele: any) => ele.bookingId === idOfBooking) // props.particularBookingDetails[0].bookingId)
		.map((item: any) => {
			return item.items[0].workshopId;
		}, {});

	const addressString = (addressDetails: any) => {
		const typeOfAddress = addressDetails.profileLocationName;
		const lat = addressDetails.latitude;
		const long = addressDetails.longitude;
		const foundAdd = props.userAddressList.find(
			(address: any, ind: any) =>
				address.addressType === typeOfAddress &&
				address.latitude === lat &&
				address.longitude === long
		);
		if (!!foundAdd) {
			const address_string = `${foundAdd.addressline1},
           ${foundAdd.landmark},
           ${foundAdd.city},
           ${foundAdd.postalCode},
           ${foundAdd.country}`;
			return address_string;
		}
		return "";
	};

	const fetchBookingDetails = async () => {
		// await props.getBookingEvents(idOfBooking);
		const currentBookingDetails = await props.fetchBookingWithId(idOfBooking);
		if (!!currentBookingDetails && currentBookingDetails.status === "SUCCESS") {
			currentBookingDetails.data.forEach(function (tEvents: any, inx: any, obj: any) {
				tEvents.events.forEach(function (item: any, index: any, object: any) {
					if (
						item.name === "Awaiting for Garage/ Driver mapping" ||
						item.name === "Confirmed" ||
						item.name === "Pickup Scheduled" ||
						item.name === "Dropped at Garage"
					) {
						object.splice(index, 1);
					}
				});
			});

			// props.clearParticularBooking();
			// console.log("1............", currentBookingDetails);

			currentBookingDetails.data.forEach(function (tEvents: any, inx: any, obj: any) {
				tEvents.events.forEach(function (item: any, index: any, object: any) {
					if (item.category === "Booking Status" && item.name === "Confirmed") {
						object.splice(index, 1);
					}
				});
			});

			const { data = [] } = currentBookingDetails;
			if (!!data.length) {
				const bookedServiceIds = (data[0].items || []).map((ser: any, ind: any) => {
					return ser.serviceId;
				});

				const vMake = props.userVehiclesList.find(
					(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
				);

				console.log("GMS = Make ==== 02", vMake);

				const bookedItemDetails = await props.getMultiServiceData({
					serviceIdList: bookedServiceIds,
					bookingId: idOfBooking,
					clientName: constants.CLIENT_NAME,
					make: vMake.make,
				});

				const { data: bkdItemDts = [] } = bookedItemDetails;
				const Booking_Det = bkdItemDts.map((val: any, ind: any) => {
					return {
						...data[0].items[ind],
						...val,
					};
				});

				setBkngDetails(Booking_Det);
			}
		}

		const wsImages = await props.getWorkshopImages(idOfBooking);

		if (!!wsImages) {
			if (!!wsImages.error) {
			} else {
				const result = Object.keys(wsImages).map((key) => wsImages[key]);

				var filtered = result.filter(function (el) {
					return el != null;
				});

				setWshopImages(filtered);
			}
		}
	};

	const handleAddress = (label: any) => {
		setAddressLabel(label);
		setShowAddModal(true);
	};

	const uploadImage = async (event: any, id: any) => {
		try {
			const file = event.target.files[0];
			if (["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
				event.preventDefault();
				const fd = new FormData();
				const base64Image: any = await toBase64(event.target.files[0]);
				const convertedFIle: any = await imageConversion(base64Image, id);
				fd.append("file", convertedFIle);

				// console.log("IMG in Details Uloaded =======", id);
				const res = await props.uploadBookingImage(id, fd);
				return res;
			} else {
				setToast({
					showToast: true,
					toastMessage: ".PNG, .JPEG, .JPG are allowed",
					severity: "warning",
				});
			}
		} catch (error: any) {
			console.error(error);
		}
	};

	const toBase64 = (file: any) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	const imageConversion = (imageData: any, id: string) => {
		return fetch(imageData)
			.then((res) => res.blob())
			.then(async (blob) => {
				const b: any = blob;
				b.lastModifedDate = new Date();
				b.name = "testimg.jpeg";
				const file = new File([b], "image.png", { type: "image/png" });
				return file;
			});
	};

	const removeCreatedAtObject = (data: any) => {
		let vehicleRegNo = "";
		let variant = "";
		let year = "";

		if (particularBookingDetails.length) {
			const registrationNumberList = props.userVehiclesList.filter(
				(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
			);
			vehicleRegNo = registrationNumberList[0].registrationNumber;
			variant = registrationNumberList[0].variant;
			year = registrationNumberList[0].year;
		}

		let startUTCTime = moment.utc(
			new Date(
				moment(new Date(date)).format("YYYY-MM-DD") + "T" + slot.split("-")[0] + ":00"
			)
		);

		let endUTCTime = moment.utc(
			new Date(
				moment(new Date(date)).format("YYYY-MM-DD") + "T" + slot.split("-")[1] + ":00"
			)
		);

		// const vehicle_id = props.userVehiclesList.filter(
		//   (ele: any) => (props.selectedVehicleRef || "").split("/").pop() === ele.did,
		// );

		const { createdAt, ...rest } = data;
		return {
			...rest,
			payments: rest.payments.map((ele: any) => {
				const { createdAt, ...rest } = ele;
				return rest;
			}),
			orders: rest.orders.map((ele: any) => {
				const { createdAt, ...rest } = ele;
				return rest;
			}),
			startTime: startUTCTime.toISOString(),
			endTime: endUTCTime.toISOString(),
			workshopId: getWorkShopId[0],
			customerName: props.name || "",
			vehicleNumber: vehicleRegNo || "",
			mobileNumber: props.primaryPhoneNumber.replace("+971", "") || "",

			catalogVehicleId: props.sliderCatelogVehicleId, // vehicle_id[0].catalogVehicleId,
			variant: variant, // "S DRIVE 18i",
			year: year,
		};
	};

	const deleteBooking = async () => {
		const updateStatus = "Cancelled";
		if (BkngDetails.length) {
			const res = await props.cancelBooking(
				// { ...booking, status: updateStatus },
				idOfBooking,
				"Booking cancelled successfully"
			);

			// if (!!res && res.status === "SUCCESS") {
			// console.log("DELETE SUCCESS ===", res);
			const resFetch = await props.fetchBookings();
			// }
		}
		props.history.goBack();
	};

	const AccessNativeCamera = async (id: any) => {
		Camera.getPicture(options).then(
			async (imageData) => {
				const file = await imageConversion("data:image/jpeg;base64," + imageData, id);
				const formData = new FormData();
				formData.append("file", file.name[0]);
				const res = await props.uploadBookingImage(id, formData);
			},
			(err: any) => {
				console.error(err, "CamError");
			}
		);
	};

	const events = !!data_obj ? data_obj.events : [];
	const findEventCategory = !!events[events.length - 1]
		? events[events.length - 1].category
		: "";
	const event_cat_ind = statusArr.findIndex((ele) => ele.key === findEventCategory);
	const findname = !!events[events.length - 1] ? events[events.length - 1].name : "";

	const getStatus = (item: any) => {
		// const cur = moment().toDate().getTime();
		// const y =
		//   !!item.updatedAt &&
		//   new Date(
		//     moment(new Date(item.updatedAt)).format("DD-MM-YYYY hh:mm:ss")
		// ).getTime();
		if (!!item.updatedAt) {
			return true;
		} else {
			return false;
		}
	};

	const changeDateandTime = async () => {
		try {
			if (!slot) {
				throw Error("Please select a slot");
			}
			setShowSlotModal(!showSlotModal);
			if (!!particularBookingDetails[0].pickupDropoffData) {
				particularBookingDetails[0].pickupDropoffData.pickupDate = moment(
					new Date(date)
				).format("YYYY-MM-DD");
				const obj = {
					startTime: !!slot.split("-")[0] ? slot.split("-")[0] : "",
					endTime: !!slot.split("-")[1] ? slot.split("-")[1] : "",
				};
				particularBookingDetails[0].pickupDropoffData.pickupSlot = obj;
			}
			const updatedObject = removeCreatedAtObject(particularBookingDetails[0]);
			await props.rescheduleBooking(updatedObject, idOfBooking);
		} catch (error: any) {
			setToast({
				showToast: true,
				toastMessage: error.message,
				severity: "warning",
			} as any);
		}
	};

	const changePickOrDropLocation = async (value: any, loc: any) => {
		loc === "pickup" ? setPickAdd(value) : setDropAdd(value);
		const data = value.pop();
		const { pickupDropoffData } = particularBookingDetails[0];
		if (loc === "pickup") {
			pickupDropoffData.pickupLocation = {
				latitude: data.latitude,
				longitude: data.longitude,
				profileLocationName: data.addressType,
			};
		}
		if (loc === "dropAt") {
			pickupDropoffData.dropoffLocation = {
				latitude: data.latitude,
				longitude: data.longitude,
				profileLocationName: data.addressType,
			};
		}
		const updatedObject = removeCreatedAtObject(particularBookingDetails[0]);
		await props.rescheduleBooking(updatedObject, idOfBooking);
	};

	const PaymentPending = {
		statusImg: "/images/PaymentPending.svg",
		statusLabel: constants.PAYMENT_PENDING,
		statusSummary1: `Please Complete the payment of ${constants.RupeeSymbol}${
			!!particularBookingDetails.length
				? Number(particularBookingDetails[0].estimate.totalEstimated) -
				  Number(particularBookingDetails[0].estimate.discount) -
				  Number(particularBookingDetails[0].estimate.advancePayment)
				: ""
		}`,
		statusSummary2: `on your Booking : ${
			!!particularBookingDetails.length ? particularBookingDetails[0].bookingCode : ""
		}`,
		banerColor: "#FF7D2F",
	};

	const PaymentSuccessful = {
		statusImg: "/images/bookingConfirmed.svg",
		statusLabel: "Payment Successful",
		statusSummary1: `Your payment of ${constants.RupeeSymbol}${
			!!particularBookingDetails.length
				? Number(particularBookingDetails[0].estimate.totalEstimated) -
				  Number(particularBookingDetails[0].estimate.discount) -
				  Number(particularBookingDetails[0].estimate.advancePayment)
				: ""
		} on your `,
		statusSummary2: `Booking : ${
			!!particularBookingDetails.length ? particularBookingDetails[0].bookingCode : ""
		} is Successful`,
		banerColor: "var(--ion-color-lightgreen)",
	};

	const PaymentFailed = {
		statusImg: "/images/bookingCancelled.svg",
		statusLabel: "Payment Failed",
		statusSummary1: `Any deducted amount will be refunded back, Please`,
		statusSummary2: `contact us or try again`,
		banerColor: "var(--ion-color-darkpink)",
	};

	const PaymentCancelled = {
		statusImg: "/images/bookingCancelled.svg",
		statusLabel: "Payment Cancelled",
		statusSummary1: `Any deducted amount will be refunded back, Please`,
		statusSummary2: `contact us or try again`,
		banerColor: "var(--ion-color-darkpink)",
	};

	const bookingConfirmed = {
		statusImg: "/images/bookingConfirmed.svg",
		statusLabel: constants.BOOKING_CONFIRMED,
		statusSummary1: !!particularBookingDetails.length
			? particularBookingDetails[0].isPickupRequired
				? "Our Executive Will Come And Pick"
				: "We will send the garage address after it’s"
			: "",
		statusSummary2: !!particularBookingDetails.length
			? particularBookingDetails[0].isPickupRequired
				? "Your Vehicle From Your Location"
				: "assigned within few hours"
			: "",
		banerColor: "var(--ion-color-lightgreen)",
	};

	const bookingCancelled = {
		statusImg: "/images/bookingCancelled.svg",
		statusLabel: constants.BOOKING_CANCELLED,
		statusSummary1: `On your request, “We are cancelling your booking `,
		statusSummary2: `as the garage has not been allocated"`,
		banerColor: "var(--ion-color-darkpink)",
		queries: constants.ASK_QUERIES,
	};
	const openFeedbackModal = () => {
		// console.log("Feedback ====");
		props.fetchFeedback();
		setShowFeedBack(true);
	};

	const RenderImages = (props: any) => {
		const length = !!props.array ? props.array.length : 0;
		return (
			<IonRow className={`added_by_div ${props.style && "workshopImages_div"}`}>
				<IonLabel className="added_by_you">{props.text}</IonLabel>
				<IonLabel className="images_added">
					{length} Image
					{length !== 1 ? "s" : " "} Added
				</IonLabel>
			</IonRow>
		);
	};

	const onDeleteUserAddedImages = async (details: any) => {
		particularBookingDetails[0].items.map((item: any) => {
			if (item.cartItemId === details.cartItemId) {
				item.images = item.images.filter((val: any) => val !== details.imgUrl);
			}
			return item;
		});
		const { createdAt, ...rest } = particularBookingDetails[0];
		const updatedObject = removeCreatedAtObject(particularBookingDetails[0]);
		const response: any = await props.rescheduleBooking(updatedObject, idOfBooking);
	};

	const handlePickupDropAddressChange = async (newAdd: any) => {
		const { latitude, longitude, addressType } = newAdd[0];
		const { pickupDropoffData } = particularBookingDetails[0];
		if (address_label === "picker") {
			pickupDropoffData.pickupLocation = {
				latitude: latitude,
				longitude: longitude,
				profileLocationName: addressType,
			};
		}
		if (address_label === "drop") {
			pickupDropoffData.dropoffLocation = {
				latitude: latitude,
				longitude: longitude,
				profileLocationName: addressType,
			};
		}
		const updatedObject = removeCreatedAtObject(particularBookingDetails[0]);
		await props.rescheduleBooking(updatedObject, idOfBooking);
	};

	function doRefresh(event: CustomEvent<RefresherEventDetail>) {
		// console.log("Begin async operation");

		setTimeout(() => {
			// console.log("Refresh Async operation has ended");
			event.detail.complete();

			fetchBookingDetails();
			handlePaymentCard();
			isPickedUp();
			// return () => {
			setBkngDetails([]);
			props.clearParticularBooking();
			// };

			// console.log("Refresh Async operation has ended ....................");
		}, 2000);
	}

	return (
		<>
			<IonContent forceOverscroll={false}>
				<IonRefresher
					slot="fixed"
					onIonRefresh={doRefresh}
					pullFactor={0.5}
					pullMin={100}
					pullMax={200}
				>
					<IonRefresherContent></IonRefresherContent>
				</IonRefresher>

				<IonCol className="middle_panle res_bg_color">
					{isPlatform("ios") && <div className="ios_statusbar_color" />}
					<div className="mar_top_30" style={{ marginTop: isPlatform("ios") ? 110 : 60 }}>
						<PageHeading
							mainHeader={
								showPaymentPendingCard
									? "Booking Details"
									: !!particularBookingDetails.length &&
									  particularBookingDetails[0].status === "InProgress" &&
									  props.bookingHeaderStatus
									? "Booking Confirmed"
									: "Booking Details"
							}
							navigation={props}
							showCart={false}
							cssClass={"booking_details_header"}
						/>
					</div>
					<div className="booking-details-parent">
						{!!particularBookingDetails.length &&
							(particularBookingDetails[0].status === "InProgress" ||
								particularBookingDetails[0].status === "Cancelled") && (
								<BookingDetailsBanner
									{...props}
									statusImg="/images/bookingConfirmed.svg"
									statusLabel={constants.BOOKING_CONFIRMED}
									statusText1={constants.SEND_GARAGE_ADD}
									statusText2={""}
									bookingId={
										!!particularBookingDetails.length
											? particularBookingDetails[0].bookingCode
											: ""
									}
									bookingStatus={
										paymentSuccess === "success"
											? PaymentSuccessful
											: paymentSuccess === "failed"
											? PaymentFailed
											: paymentSuccess === "cancelled"
											? PaymentCancelled
											: showPaymentPendingCard
											? PaymentPending
											: particularBookingDetails[0].status === "InProgress"
											? bookingConfirmed
											: bookingCancelled
									}
									paymentCb={(val: any) => setPaymentSuccess(val)}
								/>
							)}
						<div className="bc_label_parent paddingRL30" style={{ paddingLeft: 0 }}>
							<IonLabel className="bookingDets">{constants.BOOKING_DETAILS}</IonLabel>
						</div>
						<div className="rec_ser_prnt width_100per last_ele cursor_none margin-bottom-zero">
							{(BkngDetails || []).map((serVal: any, ind: any) => (
								<>
									<div key={ind} className="recomended_div">
										<IonLabel className="rec_recom">{constants.RECOMMENDED}</IonLabel>
									</div>
									<div className="rec_ser_img_div align_start">
										<IonImg
											src={
												!!serVal.service.imageUrl
													? serVal.service.imageUrl
													: "/images/settings_icon.svg" //brake_image.svg"
											}
											className="bk_ser_image"
										/>
										<div className="rec_row_wrap bking_name_align">
											<div className="tag_desc">
												<IonLabel className="rec_ser_problem">
													{serVal.service.displayName}
												</IonLabel>
												<IonLabel className="rec_ser_sub">
													{!!serVal.service.shortDescription &&
														serVal.service.shortDescription}
												</IonLabel>
												{!!serVal.type && serVal.type === "s" && (
													<IonLabel className="rec_ser_sub">Service</IonLabel>
												)}
												{!!serVal.type && serVal.type === "p" && (
													<IonLabel className="rec_ser_sub">Part</IonLabel>
												)}
												<div className="show_addon_web">
													{!!(serVal.addOnsSelected || []).length && (
														<div className="addons wrap_ele">
															<IonLabel className="addon_text">
																{constants.ADDON}
															</IonLabel>
															{serVal.addOnsSelected.map(
																(addVal: any, ind: any) =>
																	addVal.addOnId && (
																		<div
																			key={ind}
																			className="addon_container addon_margin"
																		>
																			<div className="pill_text">{`${addVal.displayName}`}</div>
																			{/* <div className="pill_text">{`${addVal.displayName}, ${constants.RupeeSymbol}${addVal.price.amount}`}</div> */}
																		</div>
																	)
															)}
														</div>
													)}
												</div>
											</div>
										</div>
										<div className="rec_ser_price_div right50">
											<IonLabel className="rec_ser_sub">
												{constants.ESTIMATED_COST}
											</IonLabel>
											<IonLabel className="rec_ser_price">
												{constants.RupeeSymbol}{" "}
												{!!serVal.pricing ? Number(serVal.pricing.amount) : ""}
											</IonLabel>
										</div>
									</div>
									<div className="show_addon_mobile">
										{!!(serVal.addOnsSelected || []).length && (
											<div className="addons wrap_ele">
												<IonLabel className="addon_text">{constants.ADDON} </IonLabel>
												{serVal.addOnsSelected.map(
													(addVal: any, ind: any) =>
														addVal.addOnId && (
															<div key={ind} className="addon_container addon_margin">
																<div className="pill_text">{`${addVal.displayName}`}</div>
																{/* <div className="pill_text">{`${addVal.displayName}, ${constants.RupeeSymbol}${addVal.price.amount}`}</div> */}
															</div>
														)
												)}
											</div>
										)}
									</div>

									{(ind + 1 < BkngDetails.length ||
										(!!particularBookingDetails.length &&
											particularBookingDetails[0].isPickupRequired &&
											!hideCancelButton)) && <div className="bd_dashed_line" />}
								</>
							))}
							{!!particularBookingDetails.length &&
								particularBookingDetails[0].status === "InProgress" && (
									<>
										{/* <div className="bd_dashed_line margin-bottom-5" /> */}
										<div className="reschedule_parent">
											<div className="action_btns">
												{!!particularBookingDetails.length &&
													// particularBookingDetails[0].isPickupRequired &&
													!hideCancelButton && (
														<>
															<IonLabel
																className="res_text cursor_pointer"
																onClick={() => setShowCalendar(true)}
															>
																{constants.RESCHEDULE}
															</IonLabel>
															<IonLabel className="res_text action_sep">
																{constants.SEPARATOR}
															</IonLabel>
														</>
													)}
												{!hideCancelButton && (
													<IonLabel
														className="res_text cursor_pointer"
														onClick={() => showAlert(!alert)}
														//onClick={() => deleteBooking()}
													>
														{constants.BD_CANCEL}
													</IonLabel>
												)}

												<AlertMessage
													showAlert={alert}
													alertMessage={"Are you sure you want to cancel the Booking ?"}
													onDidDismiss={() => {
														showAlert(false);
													}}
													alertHeader={"Delete Booking"}
													actionItemForAlert={() => {
														deleteBooking();
														showAlert(false);
													}}
												/>
											</div>
										</div>
									</>
								)}
						</div>
						<div className="rec_ser_prnt width_100per cursor_none last_ele margin-bottom-zero">
							<div className="bill_dets_container">
								<IonLabel className="bill_dets_text">{constants.BILL_DETAILS}</IonLabel>
								<IonLabel className="services_count">{`(${
									!!particularBookingDetails.length
										? particularBookingDetails[0].items.length
										: ""
								} ${constants.TWO_SERVICES}${
									!!particularBookingDetails.length
										? particularBookingDetails[0].items.length > 1
											? "s"
											: ""
										: ""
								})`}</IonLabel>
							</div>

							<div className="price_dets">
								<IonLabel className="price_label_text">{`${constants.SERVICE_TOTAL} (${constants.EXCL_TAXES})`}</IonLabel>
								<IonLabel className="ser_price">{`${constants.RupeeSymbol} ${
									!!particularBookingDetails.length
										? Number(particularBookingDetails[0].estimate.totalEstimated)
										: ""
								}`}</IonLabel>
							</div>
							<div className="price_dets">
								<IonLabel className="price_label_text">{constants.PRE_PAYMENT}</IonLabel>
								<IonLabel className="ser_price price_additional_color">{`-${
									constants.RupeeSymbol
								} ${
									!!particularBookingDetails.length
										? Number(particularBookingDetails[0].estimate.advancePayment)
										: ""
								}`}</IonLabel>
							</div>
							<div className="price_dets">
								<IonLabel className="price_label_text">
									{constants.COUPON_DISCOUNT}
								</IonLabel>
								<IonLabel className="ser_price price_additional_color">{`-${
									constants.RupeeSymbol
								} ${
									!!particularBookingDetails.length
										? Number(particularBookingDetails[0].estimate.discount)
										: ""
								}`}</IonLabel>
							</div>
							<div className="price_dets">
								<IonLabel className="price_label_text">
									{constants.TOTAL_ESTIMATED}
								</IonLabel>
								<IonLabel className="ser_price">
									{!!particularBookingDetails.length
										? `${constants.RupeeSymbol} ${
												Number(particularBookingDetails[0].estimate.totalEstimated) -
												(Number(particularBookingDetails[0].estimate.advancePayment) +
													Number(particularBookingDetails[0].estimate.discount))
										  }`
										: ""}
								</IonLabel>
							</div>
						</div>
						{!!particularBookingDetails.length &&
							!!particularBookingDetails[0].pickupDropoffData && (
								<>
									<div className="rec_ser_prnt width_100per cursor_none last_ele margin-bottom-zero">
										<div>
											<IonLabel className="ser_mode">{constants.SERVICE_MODE}</IonLabel>
											<IonLabel className="ser_val">
												{!!particularBookingDetails.length
													? particularBookingDetails[0].isPickupRequired
														? "Pickup from Location"
														: "Drop at Garage"
													: ""}
											</IonLabel>
										</div>
									</div>
									<div
										className={`rec_ser_prnt width_100per last_ele margin-bottom-zero ${
											!!particularBookingDetails.length &&
											particularBookingDetails[0].status !== "InProgress" &&
											"cursor_none"
										}`}
									>
										<div className="myloc_cont">
											<IonLabel className="loc_label">
												{!!particularBookingDetails.length &&
												particularBookingDetails[0].isPickupRequired
													? constants.PICKUP_LOC
													: constants.MY_LOCATION}
												<IonLabel className="sel_loc">
													{!!pick_add.length
														? DisplayName(pick_add)
														: !!particularBookingDetails.length
														? particularBookingDetails[0].pickupDropoffData.pickupLocation
																.profileLocationName
														: ""}
												</IonLabel>
											</IonLabel>
											{!!particularBookingDetails.length &&
												particularBookingDetails[0].status === "InProgress" &&
												!hideCancelButton && (
													<div
														className="change_text"
														onClick={() => handleAddress("picker")}
													>
														{constants.CHANGE}
													</div>
												)}
										</div>
										<IonLabel className="add_text">
											{!!pick_add.length
												? arrayToString(pick_add)
												: addressString(
														!!particularBookingDetails.length
															? particularBookingDetails[0].pickupDropoffData
																	.pickupLocation
															: ""
												  )}
										</IonLabel>
									</div>
									{!!particularBookingDetails.length &&
										particularBookingDetails[0].isPickupRequired && (
											<div
												className={`rec_ser_prnt width_100per last_ele margin-bottom-zero ${
													!!particularBookingDetails.length &&
													particularBookingDetails[0].status !== "InProgress" &&
													"cursor_none"
												}`}
											>
												<div className="myloc_cont">
													<IonLabel className="loc_label">
														{constants.DROP_LOC}
														<IonLabel className="sel_loc">
															{!!drop_add.length
																? DisplayName(drop_add)
																: !!particularBookingDetails.length
																? particularBookingDetails[0].pickupDropoffData
																		.dropoffLocation.profileLocationName
																: ""}
														</IonLabel>
													</IonLabel>
													{!!particularBookingDetails.length &&
														particularBookingDetails[0].status === "InProgress" &&
														!hideCancelButton && (
															<div
																className="change_text"
																onClick={() => handleAddress("drop")}
															>
																{constants.CHANGE}
															</div>
														)}
												</div>
												<IonLabel className="add_text">
													{!!drop_add.length
														? arrayToString(drop_add)
														: addressString(
																!!particularBookingDetails.length
																	? particularBookingDetails[0].pickupDropoffData
																			.dropoffLocation
																	: ""
														  )}
												</IonLabel>
											</div>
										)}
									{!!showAddModal && (
										<UserAddressModal
											{...props}
											confirm={true}
											showAddModal={showAddModal}
											closeAddModal={() => setShowAddModal(false)}
											openMapModal={() => setShowMap(true)}
											onChangeAddress={(value: any) =>
												address_label === "picker"
													? changePickOrDropLocation(value, "pickup")
													: changePickOrDropLocation(value, "dropAt")
											}
										/>
									)}

									<IonModal
										isOpen={showMap}
										backdropDismiss={true}
										onDidDismiss={() => setShowMap(false)}
										cssClass="confirm_picker-modal "
									>
										<div className="address-confirm">
											<AddNewAddress
												{...props}
												confirm={true}
												closeMapModal={() => setShowMap(false)}
												onChangeAddress={(value: any) => {
													address_label === "picker"
														? setPickAdd(value)
														: setDropAdd(value);
													handlePickupDropAddressChange(value);
												}}
											/>
										</div>
									</IonModal>
									{!!particularBookingDetails.length &&
										!!particularBookingDetails[0].pickupDropoffData
											.pickupOrDropoffNotes && (
											<div className="rec_ser_prnt width_100per cursor_none last_ele margin-bottom-zero">
												<div className="myloc_cont">
													<IonLabel className="loc_label">
														{constants.PICKUP_DROP_INS}
													</IonLabel>
												</div>
												<IonLabel className="instr_text">
													{!!particularBookingDetails.length &&
													!!particularBookingDetails[0].pickupDropoffData
														.pickupOrDropoffNotes
														? particularBookingDetails[0].pickupDropoffData
																.pickupOrDropoffNotes
														: "N/A"}
												</IonLabel>
											</div>
										)}
									{!!data_obj.pickupDropoffData &&
										!!data_obj.pickupDropoffData.pickupDate &&
										!!data_obj.pickupDropoffData.pickupSlot && (
											<div className="rec_ser_prnt width_100per cursor_none last_ele margin-bottom-zero">
												<div className="date_cont">
													<IonImg
														src="/images/yellow_calendar.svg"
														className="yellow_cal"
													/>
													<IonLabel className="date_text">
														{!!data_obj.pickupDropoffData &&
															!!data_obj.pickupDropoffData.pickupDate &&
															moment(
																new Date(data_obj.pickupDropoffData.pickupDate)
															).format("DD MMM YYYY")}
														{", "}
														{!!data_obj.pickupDropoffData &&
															!!data_obj.pickupDropoffData.pickupSlot.startTime &&
															data_obj.pickupDropoffData.pickupSlot.startTime}
														{/* 15 January 2020, 10:30 AM */}
													</IonLabel>
												</div>
											</div>
										)}
								</>
							)}
						{!!particularBookingDetails.length && !!particularBookingDetails[0].notes && (
							<div className="rec_ser_prnt width_100per cursor_none last_ele margin-bottom-zero">
								<div className="myloc_cont">
									<IonLabel className="loc_label">{constants.SERVICE_NOTES}</IonLabel>
								</div>
								<IonLabel className="instr_text">
									{particularBookingDetails[0].notes}
								</IonLabel>
							</div>
						)}

						<div
							className={`rec_ser_prnt width_100per last_ele margin-bottom-zero ${
								(!!particularBookingDetails.length &&
									particularBookingDetails[0].status !== "InProgress") ||
								(!!data_obj && !!data_obj.userImages && data_obj.userImages.length > 0)
									? "cursor_none"
									: ""
							}`}
							style={{ position: "relative" }}
						>
							{!!particularBookingDetails.length &&
							particularBookingDetails[0].status === "InProgress" ? (
								<>
									{(!!data_obj &&
										!!data_obj.userImages &&
										data_obj.userImages.length > 0) ||
									!!userUploadedImages.length ? (
										<div className="date_cont">
											<IonImg src="/images/img_demo.svg" className="yellow_cal" />
											<IonLabel className="date_text">{constants.IMAGES}</IonLabel>
										</div>
									) : (
										<div
											className="add_img_cont"
											onClick={(event: any) => {
												if (isPlatform("mobile") || isPlatform("mobileweb")) {
													return !!data_obj.userImages && data_obj.userImages.length
														? null
														: AccessNativeCamera(idOfBooking);
												}
											}}
										>
											<div className="date_cont">
												<IonImg src="/images/img_demo.svg" className="yellow_cal" />
												<IonLabel className="date_text">
													{constants.ADD_IMAGES}
													<span className="optional">{constants.OPTIONAL}</span>
												</IonLabel>
											</div>

											<IonImg src="/images/add-image.svg" className="yellow_cal" />
											{(isPlatform("desktop") || isPlatform("mobileweb")) && (
												<input
													type="file"
													className="input_type_file_cart_image"
													accept=".png , .jpg, .jpeg"
													onChange={(event) => {
														uploadImage(event, idOfBooking);
													}}
												/>
											)}
										</div>
									)}

									{!!userUploadedImages && userUploadedImages.length > 0 && (
										<>
											<RenderImages
												text={"Added by you"}
												array={!!userUploadedImages ? userUploadedImages : []}
											/>
											<div className="upload-cart-images horizontal_alignment booking_images">
												{userUploadedImages.map((img: any, index: any) => (
													<div
														className="upload-rc-documents height_width_90 margin_hor_5 cursor_none"
														key={index}
													>
														<CustomIonImage imgpath={img.imgUrl} key={img.imgUrl} />
														<IonImg
															src={"/images/close-icon.svg"}
															className="document-remove-icon top_right_5"
															onClick={() => {
																if (img.type === "userImages") {
																	props.deleteBookingImage(idOfBooking, {
																		url: img.imgUrl,
																	});
																} else {
																	onDeleteUserAddedImages(img);
																}
															}}
														/>
													</div>
												))}
												<div className="upload-rc-documents height_width_90">
													<div
														onClick={(event: any) => {
															if (isPlatform("mobile") || isPlatform("mobileweb")) {
																AccessNativeCamera(idOfBooking);
															}
														}}
													>
														<IonImg src={"/images/add.svg"} />
														{(isPlatform("desktop") || isPlatform("mobileweb")) && (
															<input
																type="file"
																className="input_type_file_cart_image"
																accept=".png , .jpg, .jpeg"
																onChange={async (event) => {
																	await uploadImage(event, idOfBooking);
																}}
															/>
														)}
													</div>
												</div>
											</div>
										</>
									)}
								</>
							) : (
								<div>
									<div className="date_cont">
										<IonImg src="/images/img_demo.svg" className="yellow_cal" />
										<IonLabel className="date_text">Images</IonLabel>
									</div>

									<RenderImages
										text={"Added by you"}
										array={!!userUploadedImages ? userUploadedImages : []}
									/>
									{!!userUploadedImages && userUploadedImages.length > 0 && (
										<div className="upload-cart-images horizontal_alignment booking_images">
											{userUploadedImages.map((img: any, index: any) => (
												<>
													{/* <IonText>{JSON.stringify(userUploadedImages)}</IonText> */}
													<div
														className="upload-rc-documents height_width_90 margin_hor_5 cursor_none"
														key={index}
													>
														<CustomIonImage imgpath={img.imgUrl} />
													</div>
												</>
											))}
										</div>
									)}
								</div>
							)}
							{/* {!!data_obj && !!data_obj.workshopImages && data_obj.workshopImages.length > 0 && ( */}
							{!!wshopImages && wshopImages.length > 0 && (
								<>
									<RenderImages
										text={"Added by workshop"}
										array={!!wshopImages ? wshopImages : []}
										//array={!!data_obj && !!data_obj.workshopImages ? data_obj.workshopImages : []}
										style={{ marginTop: 0 }}
									/>
									<div className="upload-cart-images horizontal_alignment booking_images">
										{/* {data_obj.workshopImages.map((img: any, index: any) => ( */}
										{wshopImages.map((img: any, index: any) => (
											// {!!img(
											<div
												className="upload-rc-documents height_width_90 margin_hor_5 cursor_none"
												key={index}
											>
												<IonImg
													style={{
														height: "100%",
													}}
													src={"https://carzimages.s3.amazonaws.com/" + img}
												/>

												{/* <CustomIonImage imgpath={"https://carzimages.s3.amazonaws.com/" + img} /> */}
											</div>
											// )}
										))}
									</div>
								</>
							)}
						</div>

						<ToastMessage
							showToast={toast.showToast}
							ToastMessage={toast.toastMessage}
							severity={toast.severity}
							onDidDismiss={() => {
								setToast({
									showToast: false,
									toastMessage: "",
									severity: "",
								});
							}}
						/>

						{/* <div
            className={
              !!particularBookingDetails.length &&
              !particularBookingDetails[0].isFeedbackGiven &&
              particularBookingDetails[0].status === "Completed"
                ? "rec_ser_prnt width_100per cursor_none bd_last_ele timeline_parent mobile_padding"
                : "rec_ser_prnt width_100per cursor_none timeline_parent mobile_padding"
            }
            style={isPlatform("mobileweb") ? { marginBottom: 55 } : {}}
          > */}
						{/* <div className="myloc_cont">
              <IonLabel className="loc_label">{constants.SERVICE_STATUS}</IonLabel>
            </div> */}

						{/* <div
              className="btn_parent_div bt_left_40"
              style={{
                marginRight: checkMediaQuery() ? 25 : 0,
                marginLeft: checkMediaQuery() ? 25 : 40,
                marginTop: checkMediaQuery() ? 20 : 30,
                width: "-webkit-fill-available",
              }}
            > */}

						{/* <IonButton
            color="primary"
            className="continue_btn child_btn"
            expand="block"
            style={{
              marginBottom: 30,
              marginTop: 10,
              minWidth: "auto",
              width: "100%",
              maxWidth: checkMediaQuery() ? "none" : "100%",
            }}
            onClick={() => {
              getFeedBacklink();
            }}
          >
            {constants.CLICK_FOR_STATUS}
          </IonButton> */}

						{/* </div> */}

						<div className="margin_top_30">
							<div className="srvc_tline_web">
								{statusArr.map((ele: any, ind: any) => (
									<div key={ind} className="status_container">
										<div className="circle_div ">
											<div
												className={
													ele.active ||
													(ind - 1 >= 0 &&
														statusArr[ind - 1].details.every(
															(y: any) => !!y.updatedAt
														)) ||
													(ind === 0 && !ele.active)
														? "active_dot"
														: "inactive_dot"
												}
												style={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}
											>
												{!!ele.percentage && (
													<div className="circularCont">
														<CircularProgressbar
															value={ele.percentage}
															strokeWidth={12}
															styles={buildStyles({
																strokeLinecap: "butt",
																pathColor: "white",
																trailColor: "rgba(255, 255, 255, 0.5)",
															})}
														/>
													</div>
												)}
											</div>
											{ind < statusArr.length - 1 && <div className="ver_line" />}
										</div>
										<div
											className={
												ele.active ||
												(ind - 1 >= 0 &&
													statusArr[ind - 1].details.every((y: any) => !!y.updatedAt)) ||
												(ind === 0 && !ele.active)
													? "event_parent"
													: "event_parent margin_top_10"
											}
										>
											<div className="event_parent_mobile">
												<div
													className={
														ele.active ||
														(ind - 1 >= 0 &&
															statusArr[ind - 1].details.every(
																(y: any) => !!y.updatedAt
															)) ||
														(ind === 0 && !ele.active)
															? "active_statusDot_mobile"
															: "statusDot_mobile"
													}
													style={{
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													}}
												>
													{!!ele.percentage && (
														<div className="circularCont">
															<CircularProgressbar
																value={ele.percentage}
																strokeWidth={12}
																styles={buildStyles({
																	strokeLinecap: "butt",
																	pathColor: "white",
																	trailColor: "rgba(255, 255, 255, 0.5)",
																})}
															/>
														</div>
													)}
												</div>
												<IonLabel
													className={
														ele.active ||
														(ind - 1 >= 0 &&
															statusArr[ind - 1].details.every(
																(y: any) => !!y.updatedAt
															)) ||
														(ind === 0 && !ele.active)
															? "booked_date_mob"
															: "booked_date_mob inactive_booked_date_mob"
													}
												>
													{ele.key}
												</IonLabel>
											</div>
											<IonLabel
												className={
													ele.active ||
													(ind - 1 >= 0 &&
														statusArr[ind - 1].details.every(
															(y: any) => !!y.updatedAt
														)) ||
													(ind === 0 && !ele.active)
														? "booked_date"
														: "booked_date inactive_booked_date"
												}
											>
												{ele.key}
											</IonLabel>

											<div className="sub_status_div">
												{ele.details.map((item: any, index: any) => (
													<div key={index} className="status_cont">
														<div className="dot_line">
															<div className="status_ver_line" />
															<div
																className={
																	getStatus(item)
																		? "status_dot"
																		: (!item.updatedAt &&
																				index - 1 >= 0 &&
																				!!ele.details[index - 1].updatedAt) ||
																		  (ind - 1 >= 0 &&
																				statusArr[ind - 1].details.every(
																					(y: any) => !!y.updatedAt
																				) &&
																				index === 0) ||
																		  (ind === 0 && index === 0) // Booked also null
																		? "orange_dot"
																		: "inactive_status_dot"
																}
															/>
															<div
																className={
																	item.name !== "Dropped at your location"
																		? "status_ver_line"
																		: "tran_line"
																}
															/>
														</div>
														<div className="status_text_div">
															<IonLabel
																className={`status_val ${
																	!!item.updatedAt
																		? "active_text"
																		: (!item.updatedAt &&
																				index - 1 >= 0 &&
																				!!ele.details[index - 1].updatedAt) ||
																		  (ind - 1 >= 0 &&
																				statusArr[ind - 1].details.every(
																					(y: any) => !!y.updatedAt
																				) &&
																				index === 0) ||
																		  (ind === 0 && index === 0)
																		? "inprogress_text"
																		: ""
																}`}
															>
																{item.name}
															</IonLabel>
															{/* {!!item.updatedAt && (
                              <IonLabel className={`status_val`}>
                                {", "}
                                {moment(moment(`${item.updatedAt}`, "DD-MM-YYYY hh:mm:ss")).format(
                                  "DD MMM, hh:mm A",
                                )}
                              </IonLabel>
                            )} */}
														</div>
													</div>
												))}
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
						{/* </div> */}
					</div>
					{particularBookingDetails.length &&
						!particularBookingDetails[0].isFeedbackGiven &&
						particularBookingDetails[0].status === "Completed" && (
							<div className="confirm_btn_bottom share-feedback">
								<div className="sd_col widthHundredPer">
									<IonLabel className="sd_escost">
										{constants.HOW_WAS_THE_SERVICE}
									</IonLabel>
									<div className="feedback_cont" onClick={() => openFeedbackModal()}>
										<IonLabel className="pay_value">
											{constants.PLEASE_SHARE_FEEDBACK}
										</IonLabel>
										<img
											src="/images/right_arrow_white.svg"
											className="right_arrow_white"
										/>
									</div>
								</div>
							</div>
						)}
				</IonCol>
			</IonContent>

			<FeedbackModal
				{...props}
				visible={showFeedback}
				close={() => setShowFeedBack(false)}
				bookingId={idOfBooking}
				goBack={() => props.history.goBack()}
			/>

			<IonModal
				isOpen={showCalendar}
				onDidDismiss={() => setShowCalendar(false)}
				cssClass="picker-modal"
			>
				<div className="picker-header">
					<IonLabel className="picker-header-year">
						{new Date(date).getFullYear()}
					</IonLabel>
					<div className="picker-header-month-date-div">
						<IonLabel className="picker-header-month-date">
							{days[new Date(date).getDay() - 1]}
							{", "}
						</IonLabel>
						<IonLabel className="picker-header-month-date">
							{new Date(date).getDate()}{" "}
						</IonLabel>
						<IonLabel className="picker-header-month-date">
							{months[new Date(date).getMonth()]}
						</IonLabel>
					</div>
				</div>
				<Calendar
					onChange={(date: any) => changeDate(date)}
					value={new Date(date)}
					minDate={new Date(props.firstAvailable)}
					maxDate={new Date(props.lastAvailable)}
					defaultActiveStartDate={new Date()}
				/>
				<div className="picker-actions-div">
					<IonButton
						onClick={() => {
							// setDate(new Date());
							setShowCalendar(!showCalendar);
						}}
						color="light"
						className="picker-action-buttons"
					>
						{constants.CANCEL}
					</IonButton>
					<IonButton
						color="light"
						className="picker-action-buttons"
						onClick={() => {
							setShowCalendar(!showCalendar);
							if (
								date >= new Date(props.firstAvailable) &&
								date <= new Date(props.lastAvailable) &&
								!!time_arr &&
								time_arr.length > 0
								// !!props.time_slots &&
								// props.time_slots.length > 0
							) {
								setShowSlotModal(true);
							}
						}}
					>
						{constants.OK}
					</IonButton>
				</div>
			</IonModal>
			<IonModal
				isOpen={showSlotModal}
				cssClass="slot-modal"
				onDidDismiss={() => setShowSlotModal(false)}
			>
				<div>
					<div className="slot_header">
						<IonLabel className="slot_heading">Choose a time slot</IonLabel>
					</div>
					<div
						className={
							time_arr.length > 7
								? "slot_container"
								: time_arr.length > 6
								? "slot_container_6"
								: time_arr.length > 5
								? "slot_container_small"
								: time_arr.length > 3
								? "slot_container_xxsmall"
								: "slot_container_xxsmall"
						}
					>
						{/* {props.time_slots.map((ele: any, ind: number) => ( */}
						{time_arr.map((ele: any, ind: number) => (
							<div
								key={ind}
								onClick={() => changeTimeSlot(`${ele.startTime}-${ele.endTime}`)}
								className={
									slot === `${ele.startTime}-${ele.endTime}` ? "active_slot" : "slot_val"
								}
							>
								{ele.startTime}-{ele.endTime}
							</div>
						))}
					</div>
				</div>
				<div className="picker-actions-div">
					<IonButton
						onClick={() => {
							setTimeSlot("");
							setShowSlotModal(!showSlotModal);
						}}
						color="light"
						className="picker-action-buttons"
					>
						{constants.CANCEL}
					</IonButton>
					<IonButton
						color="light"
						className="picker-action-buttons"
						onClick={() => {
							setTimeSlot("");
							changeDateandTime();
						}}
					>
						{constants.OK}
					</IonButton>
				</div>
			</IonModal>
		</>
	);
};
export default connect(
	({ booking, cart, userInfo, auth }: any) => {
		const { particularBookingDetails, bookingHeaderStatus, bookingList } = booking;
		const { primaryPhoneNumber, email, name, defaultAddressRef } = auth;
		const {
			booking_details_service_data,
			time_slots,
			firstAvailable,
			lastAvailable,
			service_data_value,
			cart_items,
		} = cart;
		const { userAddressList, sliderCatelogVehicleId, userVehiclesList } = userInfo;
		return {
			bookingList,
			sliderCatelogVehicleId,
			particularBookingDetails,
			booking_details_service_data,
			userAddressList,
			userVehiclesList,
			time_slots,
			firstAvailable,
			lastAvailable,
			service_data_value,
			cart_items,
			primaryPhoneNumber,
			email,
			name,
			bookingHeaderStatus,
			defaultAddressRef,
		};
	},
	{
		fetchBookingWithId,
		getMultiServiceData,
		getTimeSlots,
		uploadBookingImage,
		saveServiceData,
		deleteBookingImage,
		deleteBookingTransaction,
		rescheduleBooking,
		cancelBooking,
		fetchBookings,
		// fetchReservationsFeedback,
		getBookingEvents,
		getWorkshopImages,
		fetchFeedback,
		razorpayCallBack,
		saveBookingDetailsHeaderStatus,
		clearParticularBooking,
		getAdvancePaymentOrderId,
	}
)(BookingDetails);
